/*!
  SVG Regions Map
 */
var $ = require('jquery');

$(function() {
  $(document).on('click', '.js_svgRegion', function(e){
    e.preventDefault();

    var svgRegion = $(this),
        resultPanel = $('.js_svgMapRegionResult');

    // Back to default
    if($(this).hasClass('active')) {
      $(this).removeClass('active');
      resultPanel.text('Vyberte region na mapě');
    } else {
      // Remove active class from all regions and add to clicked
      svgRegion.removeClass('active');
      $(this).addClass('active');

      // Update string accordingly
      var str = $(this).attr('id');
      if(str==='msk'){str='Moravskoslezský kraj'}
      if(str==='vys'){str='Kraj Vysočina'}
      if(str==='kvk'){str='Karlovarský kraj'}
      if(str==='plk'){str='Plzeňský kraj'}
      if(str==='pha'){str='Hlavní město Praha'}
      if(str==='stc'){str='Středočeský kraj'}
      if(str==='ulk'){str='Ústecký kraj'}
      if(str==='lbk'){str='Liberecký kraj'}
      if(str==='pak'){str='Pardubický kraj'}
      if(str==='hkk'){str='Královéhradecký kraj'}
      if(str==='olk'){str='Olomoucký kraj'}
      if(str==='jhm'){str='Jihomoravský kraj'}
      if(str==='zlk'){str='Zlínský kraj'}
      if(str==='jhc'){str='Jihočeský kraj'}
      // Reformat string
      resultPanel.text(str);
    }
  });
});



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/svgRegionsMap.js